module.exports = __webpack_public_path__ + "static/background-13251691a37e52f9eda4763956728f92.jpg";